import Cookies from 'js-cookie';

import { HttpClient } from 'shared/libs/http';
import { MainAnalyticsResponse } from './main-analytics.types';

export class MainAnalyticsApiService {
   public static async load() {
      const tokenKey = Cookies.get('token');
      const adminID = Cookies.get('adminID');

      return await HttpClient.post<MainAnalyticsResponse>('/admin/dashboard', null, {
         headers: {
            adminid: adminID,
            Authorization: `Bearer ${tokenKey}`,
         },
      });
   }
}
